@if (chat(); as ch) {
    <div class="vz-chat-row layout flex bg of-h" (click)="itemClick.emit($event)">
        <div class="layout" (click)="selectable() ? checked.set(!checked()) : null">
            <div class="layout relative center-center" [class.vz-table-row-selector]="selectable()">
                <vz-chat-avatar [size]="avatarSize()" [chatId]="chatId()" />
                @if (selectable()) {
                    <label nz-checkbox [ngModel]="checked()"></label>
                }
            </div>
        </div>
        <div class="layout flex center ml05 of-h">
            <div class="layout flex vertical of-h">
                <div class="layout center">
                    <div class="layout flex relative of-h lh11 elli-wrap">
                        @if (ch.type == CT.Direct) {
                            <span class="elli"
                                vz-names-list
                                [ids]="ch.thread.commentators"
                                [onlySelfName]="'Избранное'">
                            </span>
                        }
                        @else {
                            <span class="elli"[class.fw-b]="ch.thread.unreadCount > 0 || ch.hasUnreadThreads">{{ ch.title }}</span>
                        }
                    </div>
                </div>
                @if (ch.type != CT.Direct && ch.description && !noDescription()) {
                    <div class="layout relative of-h lh11 elli-wrap">
                        <small class="elli txt-l">{{ ch.description }}</small>
                    </div>
                }
            </div>
            <div class="layout vertical center-justified mh025">
                @if (ch.call && ch.call.status != CCS.Finished) {
                    <span class="vzi-call txt-a fs-xl" style="margin-right: 2px"></span>
                }
                @if (ch.thread.unreadCount > 0 || ch.hasUnreadThreads) {
                    <div class="vz-badge-old-xxl"
                        [class.vz-badge-old]="!ch.muted && ch.type != CT.Direct"
                        [class.vz-badge-old-err-bg]="!ch.muted && ch.type == CT.Direct"
                        [class.vz-badge-old-ll]="ch.muted">
                        @if (ch.thread.unreadCount > 0) {
                            {{ ch.thread.unreadCount }}
                        }
                        @else {
                            <span class="vzi-alt_route r180" style="width: 14px; font-size: 14px; margin-right: -3px; margin-left: -3px; display: inline-block;"></span>
                        }
                    </div>
                }
            </div>
        </div>
    </div>
}
